var map = {
	"./de-DE.json": [
		"IdXX",
		45
	],
	"./en-US.json": [
		"IFIa"
	],
	"./es-419.json": [
		"uGlq",
		44
	],
	"./fr-FR.json": [
		"znoz",
		43
	],
	"./it-IT.json": [
		"JO1e",
		42
	],
	"./nl-NL.json": [
		"WROx",
		41
	],
	"./pl-PL.json": [
		"6X3a",
		40
	],
	"./pt-BR.json": [
		"wJOA",
		39
	],
	"./th-TH.json": [
		"BhAd",
		38
	],
	"./tr-TR.json": [
		"8YNv",
		37
	],
	"./zh-TW.json": [
		"bSGe",
		36
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "DX4b";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/locale lazy ^\.\/.*\.json$
// module id = DX4b
// module chunks = 47